import { createRoute } from '@tanstack/react-router'
import { LoginPage } from '@/features/auth/pages/LoginPage'
import { Route as rootRoute } from './__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
})
